import { Button, Typography } from '../../../designComponents';
import { ContainerStyled, PremiumStyled } from './styled';

const Premium = () => {
  return (
    <PremiumStyled>
      <ContainerStyled>
        <Typography className="main-head" strong>
          Unlock Premium Features with EscapePlan Pricing
        </Typography>
        <Typography className="main-text">
          Choose the plan that best suits your needs and enjoy exclusive
          benefits tailored to enhance your project workflow.
        </Typography>
        <Button style={{ borderRadius: '30px' }} onClick={() => {}}>
          Get Started
        </Button>
      </ContainerStyled>
    </PremiumStyled>
  );
};

export default Premium;
